import { StepContentful } from 'models/StepContentful';
import { baseService } from 'modules/baseService';
import HttpClient from 'services/HttpClient';
import { getLastUpdatedAtQuery } from 'helpers/helperFunctions';

export const getSteps = baseService<string | undefined, StepContentful[]>(
  (lastUpdatedAt) =>
    HttpClient.get(`/contentful/steps${getLastUpdatedAtQuery(lastUpdatedAt)}`),
);
